export interface OpcaoFiltroDisparo {
  id: number | string;
  nome?: string;
  titulo?: string;
  numero?: string;
}

export const FILTRO_RECORRENCIA_SESSION_KEY =
  'claribot:filtro-recorrencia-disparos';

export class DisparoAutomaticoFiltro {
  titulo = '';
  dataEnvioInicio?: Date;
  dataEnvioFim?: Date;
  programacoes: OpcaoFiltroDisparo[] = [];
  status: OpcaoFiltroDisparo[] = [];
  usuarios: OpcaoFiltroDisparo[] = [];
  setores: OpcaoFiltroDisparo[] = [];
  contas: OpcaoFiltroDisparo[] = [];
  fluxos: OpcaoFiltroDisparo[] = [];

  static payload(filtro: DisparoAutomaticoFiltro): Record<string, unknown> {
    return {
      titulo: filtro.titulo?.trim() || null,
      dataEnvioInicio: this.dataLocal(filtro.dataEnvioInicio),
      dataEnvioFim: this.dataLocal(filtro.dataEnvioFim),
      programacaoIds: filtro.programacoes.map((item) => Number(item.id)),
      status: filtro.status.map((item) => String(item.id)),
      usuarioIds: filtro.usuarios.map((item) => Number(item.id)),
      setorIds: filtro.setores.map((item) => Number(item.id)),
      numeroIds: filtro.contas.map((item) => Number(item.id)),
      fluxoIds: filtro.fluxos.map((item) => Number(item.id)),
    };
  }

  static copiar(filtro: DisparoAutomaticoFiltro): DisparoAutomaticoFiltro {
    return Object.assign(new DisparoAutomaticoFiltro(), filtro, {
      programacoes: [...filtro.programacoes],
      status: [...filtro.status],
      usuarios: [...filtro.usuarios],
      setores: [...filtro.setores],
      contas: [...filtro.contas],
      fluxos: [...filtro.fluxos],
    });
  }

  private static dataLocal(data?: Date): string | null {
    if (!data) return null;
    const valor = new Date(data);
    const ano = valor.getFullYear();
    const mes = String(valor.getMonth() + 1).padStart(2, '0');
    const dia = String(valor.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  }
}
